import { getJSON } from "../../misc/qf.js";

const calculateNumbers = function (availabilityObj, role) {
  const role1 = role === "player" ? "player" : "coach";
  const role2 = role === "player" ? "captain" : "admin";

  let totalMembers = 0;
  let available = 0;
  let undecided = 0;

  for (let v of Object.values(availabilityObj)) {
    if (v.role === role1 || v.role === role2) {
      if (v.status === "available") {
        available++;
      } else if (v.status === "undecided") {
        undecided++;
      }
      totalMembers++;
    }
  }

  return [totalMembers, available, undecided];
};

export const calculateRosterAvailabilityObj = (availabilityObj, type) => {
  const role = type.toLowerCase();
  // console.log(availabilityObj);
  let numbers = [0, 0, 0];
  if (role === "player") {
    numbers = calculateNumbers(availabilityObj, role);
  } else if (role.toLowerCase() === "coach") {
    numbers = calculateNumbers(availabilityObj, role);
  }
  return {
    available: numbers[1],
    undecided: numbers[2],
    unavailable: numbers[0] - (numbers[1] + numbers[2]),
  };
};

export const availabilityObjCaller = async function (url, team) {
  try {
    const availabilitiesObj = await getJSON(`${url}?team_id=${team.id}`);
    return availabilitiesObj;
  } catch (err) {
    throw err;
  }
};

export const teamRosterDataCaller = async function (team, role) {
  try {
    const url = team._links.roster_data.href;
    const data = await getJSON(`${url}?role=${role}`);
    return data._embedded.team_members;
  } catch (err) {
    throw err;
  }
};

export const collectMembersAndPositions = async function (team, role) {
  try {
    const url = team._links.roster_data.href;
    const data = await getJSON(`${url}?role=${role}`);
    return [data._embedded.team_members, data._embedded.positions];
  } catch (err) {
    throw err;
  }
};
